define([], ()=> {
    return ['$window', 'TransportService', 'CallTrackerService', ($window, TransportService, CallTrackerService)=> {
        return {
            send: (xCenterType, serviceEndpoint, method, params, callGroups)=> {
                CallTrackerService.registerCallStart(callGroups);
                return (
                    TransportService.send(xCenterType, serviceEndpoint, method, params)
                        .then((response)=> {
                            CallTrackerService.registerCallSuccess(callGroups);
                            return response;
                        }, (error)=> {
                            CallTrackerService.registerCallError(callGroups);
                            if (TransportService.isSessionExpiredReason(error)) {
                                //refresh the page to get to login page
                                /* mkarvonen: Set reload to true. Some "autentication solutions" does not set proper
                                 * caching headers.
                                 */
                                $window.location.reload(true);
                            }
                            throw error;
                        }));
            }
        };
    }];
});


/** WEBPACK FOOTER **
 ** ./common/js/src/edge/platform/base/JsonRPCService.js
 **/